import {SidebarCollapseIcon, SidebarExpandIcon} from '@primer/octicons-react'

import {IconButton} from '@primer/react'
import {DiffViewSettings} from './DiffViewSettings'

interface DiffsHeaderProps {
  setTreeExpanded: (treeExpanded: boolean) => void
  treeExpanded: boolean
  treeEnabled: boolean
}

export function DiffsHeader({setTreeExpanded, treeExpanded, treeEnabled}: DiffsHeaderProps) {
  return (
    <div className="d-flex flex-items-center flex-justify-between">
      <div className="d-flex flex-items-center">
        {treeEnabled && (
          <IconButton
            variant="invisible"
            icon={treeExpanded ? SidebarExpandIcon : SidebarCollapseIcon}
            onClick={() => setTreeExpanded(!treeExpanded)}
            aria-label={treeExpanded ? 'Collapse tree' : 'Expand tree'}
            sx={{mr: 2}}
          />
        )}
        Files Changed
      </div>
      <div>
        <DiffViewSettings />
      </div>
    </div>
  )
}

try{ DiffsHeader.displayName ||= 'DiffsHeader' } catch {}